import { z } from 'zod'
import { phoneNumberSchema } from 'utils/custom-schemas'

export const chargebackContactSchema = z.object({
  individual: z.object({
    firstName: z.string().min(1),
    middleName: z.string().nullish(),
    lastName: z.string().min(1),
    email: z.string().min(1).email('invalidEmail'),
    phoneNumber: phoneNumberSchema({ message: 'invalidPhoneNumber' })
  }),
  relation: z.object({
    title: z.string().min(1)
  })
})

export type ChargebackContact = z.infer<typeof chargebackContactSchema>
